import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ACTIVITY_TYPE, ROUTES } from '../../const';
import routerHistory from '../../routerHistory';
import { I18n } from 'react-redux-i18n-lite';
import './css/search-results.css';
import './css/table.css';

class SearchResultsWrapper extends React.Component {
  static propTypes = {
    searchResult: PropTypes.array
  };

  render() {
    const { searchResult } = this.props;
    if (!searchResult) {
      return <div>{routerHistory.push(ROUTES.HOME)}</div>;
    }
    return (
      <div className="main">
        <div className="content-wrapper">
          {/*<div className="selector">*/}
          {/*<span>All spaces</span>*/}
          {/*<i className="close custom-icons-triangle-arrow-icon"/>*/}
          {/*</div>*/}
          <table>
            <thead>
              <tr>
                <th className={'name-column'}>
                  <span>{I18n.t('search.name')}</span>
                </th>
                <th className={'book-column'}>{I18n.t('search.book')}</th>
                <th className={'type-column'}>{I18n.t('search.type')}</th>
                <th className={'space-column'}>{I18n.t('search.classroom')}</th>
              </tr>
            </thead>
            <tbody>
              {this.printResults(searchResult.filter(result => result.type === ACTIVITY_TYPE.LESSON))}
              {this.printResults(searchResult.filter(result => result.type === ACTIVITY_TYPE.UNIT))}
              {this.printResults(searchResult.filter(result => result.type === ACTIVITY_TYPE.BOOK))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  printResults = results => {
    return results.map(obj => {
      return (
        <tr
          key={`${obj.lessonId}-${obj.bookName}-${obj.type}-${obj.classroomName}`}
          className="result"
          onClick={() => this.launch(obj)}
        >
          <td>
            <div>
              <img src={obj.imageUrl} alt={obj.name} />
              <span>{obj.name}</span>
            </div>
          </td>
          <td className={'book-column'}>{obj.bookName}</td>
          <td className={'type-column'}>{I18n.t(`search.${obj.type.toLowerCase()}`)}</td>
          <td className={'space-column'}>
            <div>
              <img src={obj.classroomImageUrl} alt={obj.classroomName} />
              <span>{obj.classroomName}</span>
            </div>
          </td>
        </tr>
      );
    });
  };

  launchBook = element => {
    const url = `${ROUTES.CLASSROOM_BOOK.replace('_classId_', element.classroomId)}/${element.bookId}`;
    routerHistory.push(url);
  };

  launchUnit = element => {
    const url = `${ROUTES.CLASSROOM_BOOK.replace('_classId_', element.classroomId)}/${element.bookId}`;
    routerHistory.push(`${url}?selectedUnit=${element.unitId}`);
  };

  launch = element => {
    this.setState({ resultsOpened: false });
    return element.type === ACTIVITY_TYPE.BOOK ? this.launchBook(element) : this.launchUnit(element);
  };
}

function mapStateToProps(state) {
  return {
    searchResult: state.search.searchResult
  };
}

export default connect(mapStateToProps)(SearchResultsWrapper);
